import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {BunkerProductSupplier} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-bunker-product-supplier',
    templateUrl: './edit-bunker-product-supplier.component.html',
    styleUrls: ['./edit-bunker-product-supplier.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditBunkerProductSupplierComponent {
  @Input() bunkerProductSupplier: BunkerProductSupplier;
}
